import perfNow from "common/utils/perfNow";
import noop from "./noop";

export class PerfMetricsRecorder {
  startedAt: { [key: string]: number } = {};
  sum: { [key: string]: number } = {};
  count: { [key: string]: number } = {};

  private static _instance: PerfMetricsRecorder;
  static instance(): PerfMetricsRecorder {
    return PerfMetricsRecorder._instance ?? (PerfMetricsRecorder._instance = new PerfMetricsRecorder());
  }

  resetAll() {
    this.startedAt = {};
    this.sum = {};
    this.count = {};
  }

  start(id: string) {
    this.startedAt[id] = perfNow();
  }

  end(id: string) {
    if (!this.startedAt[id]) {
      console.error("no start time for", id);
      return;
    }

    this.sum[id] = (this.sum[id] || 0) + (perfNow() - this.startedAt[id]);
    delete this.startedAt[id];
    this.count[id] = (this.count[id] || 0) + 1;
  }

  report() {
    if (Object.keys(this.sum).length === 0) {
      return;
    }

    const metrics = Object.keys(this.sum).reduce((acc, key) => {
      return { ...acc, [key]: { avg: this.sum[key] / this.count[key], count: this.count[key], sum: this.sum[key] } };
    }, {});

    console.table(metrics);
  }
}

export interface PerfMarker {
  end(): void;
  measure(): void;
  endAndMeasure(): void;
}

export class PerfMarkerImpl implements PerfMarker {
  id: string;

  constructor(id: string) {
    this.id = id;
    performance.mark(`begin-${this.id}`);
  }

  end(): void {
    performance.mark(`end-${this.id}`);
  }

  measure(): void {
    performance.measure(this.id, `begin-${this.id}`, `end-${this.id}`);
  }

  endAndMeasure(): void {
    this.end();
    this.measure();
  }
}

let perfMarkersEnabled = false;

export function enablePerfMarkers(): void {
  perfMarkersEnabled = true;
}

export function createPerfMarker(id: string): PerfMarker {
  if (perfMarkersEnabled) {
    return new PerfMarkerImpl(id);
  } else {
    return {
      end: noop as () => void,
      measure: noop as () => void,
      endAndMeasure: noop as () => void,
    };
  }
}
